import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";

import { IOption } from "ng-select";
import { EvsProductService } from "../../common/services/EvsProduct.service";
import { EvsStoreService } from "../../common/services/EvsStore.service";

declare var $: any;

@Component({
  selector: "app-filter-stores",
  templateUrl: "./filter-stores.component.html",
  styleUrls: ["./filter-stores.component.css"],
  providers: [EvsProductService, EvsStoreService],
})
export class FilterStoresComponent implements OnInit {
  @Output() selectedStoreId = new EventEmitter<any>();
  @Output() selectedStoreLabel = new EventEmitter<any>();
  @Input() store: any;
  listStores: Array<IOption> = [];
  limitStore: number = 10;
  offsetStore: number = 0;
  searchStoreQuery = "";
  tmpCountBottom = 0;
  sltStoreId: any = null;
  tmp: any;

  constructor(
    private productService: EvsProductService,
    private storeService: EvsStoreService
  ) {}

  ngOnChanges(change: any) {
    let currentValue: any;
    if (change.store) {
      currentValue = change.store.currentValue;
      this.getListStores().then(() => {
        if (currentValue) {
          if (!this.currentObj) {
            this.currentObj = {
              value: currentValue.value,
              label: currentValue.label,
            };
          }
          if (
            this.listStores.map((gg) => gg.value).indexOf(currentValue.value) ==
            -1
          ) {
            let tmp = {
              value: currentValue.value,
              label: currentValue.label,
            };
            let arrTmp = this.listStores;
            arrTmp.push(tmp);
            this.listStores = arrTmp;
          }
        }
      });
    }
  }

  ngOnInit() {
    this.getListStores().then(() => {
      if (this.store) {
        if (!this.currentObj) {
          this.currentObj = {
            value: this.store.value,
            label: this.store.label,
          };
        }
        if (
          this.listStores.map((gg) => gg.value).indexOf(this.store.value) == -1
        ) {
          let tmp = {
            value: this.store.value,
            label: this.store.label,
          };
          let arrTmp = this.listStores;
          arrTmp.push(tmp);
          this.listStores = arrTmp;
        }
      }
    });

    // // when scroll to bottom of div to load more
    document.addEventListener(
      "scroll",
      (event) => {
        event.stopPropagation();
        let ele = <HTMLElement>event.target;
        if (ele) {
          let ele2 = <HTMLElement>ele.parentElement;
          if (ele2) {
            let ele3 = <HTMLElement>ele2.parentElement;
            if (ele3) {
              let ele4 = <HTMLElement>ele3.parentElement;
              if (ele4) {
                if (
                  ele.className === "options" &&
                  ele4.id == "drp-list-stores"
                ) {
                  if (ele.scrollTop === ele.scrollHeight - ele.clientHeight) {
                    this.tmpCountBottom += 1;
                    this.offsetStore = this.tmpCountBottom * this.limitStore;
                    this.tmp = this.listStores;

                    this.getListStores(this.searchStoreQuery).then(() => {
                      let tmp2: any;
                      if (this.tmp) {
                        tmp2 = this.tmp.concat(this.listStores);
                        let flagCount = 0;
                        if (this.store) {
                          if (
                            tmp2
                              .map((gg) => gg.value)
                              .indexOf(this.store.value) !=
                            tmp2
                              .map((gg) => gg.value)
                              .lastIndexOf(this.store.value)
                          ) {
                            let index = tmp2
                              .map((gg) => gg.value)
                              .lastIndexOf(this.store.value);
                            tmp2.splice(index, 1);
                          }
                        }
                      }
                      this.listStores = tmp2;
                    });
                  }
                }
              }
            }
          }
        }
      },
      true
    );

    // call api when stop typing
    var delay = (function () {
      var timer: any = 0;
      return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    // when search
    document.addEventListener("keyup", (event) => {
      event.stopPropagation();
      let ele = <HTMLElement>event.target;
      if (ele) {
        let ele2 = <HTMLElement>ele.parentElement;
        if (ele2) {
          let ele3 = <HTMLElement>ele2.parentElement;
          if (ele3) {
            let ele4 = <HTMLElement>ele3.parentElement;
            if (ele4) {
              let ele5 = <HTMLElement>ele4.parentElement;
              if (ele5) {
                if (
                  ele.parentElement.className == "filter" &&
                  ele5.id == "drp-list-stores"
                ) {
                  let inputEle = <HTMLInputElement>event.target;
                  let searchQuery = inputEle.value;

                  this.tmpCountBottom = 0;
                  this.offsetStore = 0;
                  this.listStores = null;

                  delay(() => {
                    this.searchStoreQuery = searchQuery;
                    this.getListStores(this.searchStoreQuery).then(() => {
                      let tmp = this.listStores;

                      if (tmp && this.currentObj) {
                        if (
                          !tmp.some((e) => e.value == this.currentObj.value)
                        ) {
                          tmp.push(this.currentObj);
                        }
                      }

                      this.listStores = tmp;
                    });
                  }, 500);
                }
              }
            }
          }
        }
      }
    });
  }

  // get list product variant
  getListStores(query: any = null) {
    let opt: any;
    if (query) {
      opt = {
        limit: this.limitStore,
        offset: this.offsetStore,
        name: query,
      };
    } else {
      opt = {
        limit: this.limitStore,
        offset: this.offsetStore,
      };
    }

    return this.storeService
      .getAll(opt)
      .toPromise()
      .then((res) => {
        if (!res.error && res.data.count.total) {
          let arrTmp = [];
          res.data.store.forEach((store) => {
            let item = {
              value: store.id.toString(),
              label: store.name,
            };

            if (this.currentObj) {
              if (item.value != this.currentObj.value) {
                arrTmp.push(item);
              }
            } else {
              arrTmp.push(item);
            }
          });
          this.listStores = arrTmp;
        }
      });
  }

  // when select option
  currentObj: any;
  selectedStore(e) {
    this.sltStoreId = e.value;
    this.selectedStoreId.emit(this.sltStoreId);
    this.selectedStoreLabel.emit(e.label);

    this.currentObj = {
      value: e.value,
      label: e.label,
    };
  }

  // // when deselect option
  deselectedStore(e) {
    this.sltStoreId = null;
    this.selectedStoreId.emit(this.sltStoreId);
    this.selectedStoreLabel.emit(null);
  }

  // // when open select box
  opened() {
    this.tmpCountBottom = 0;
    this.offsetStore = 0;
    this.listStores = null;
    this.searchStoreQuery = "";

    this.getListStores().then(() => {
      let tmp = this.listStores;

      if (this.currentObj) {
        if (!tmp.some((e) => e.value == this.currentObj.value)) {
          tmp.push(this.currentObj);
        }
      }

      if (this.store) {
        if (tmp.map((gg) => gg.value).indexOf(this.store.value) == -1) {
          let obj = {
            value: this.store.value,
            label: this.store.label,
          };
          tmp.push(obj);
        }
      }

      this.listStores = tmp;
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/filter-stores/filter-stores.component.ts